import {Logger}               from '@/util/logger';

/**
 *
 * @class ProjectMeta
 *
 * To manage circular dependencies among Project, ProjectElement (and subclasses) and
 * ProjectElementFactory, we register the constructors for classes in a "Meta" class
 * similar to the technique from:
 *
 *   https://stackoverflow.com/questions/44134469/typescript-nodejs-circular-dependency-while-working-with-factories
 *
 * Once we have the constructors registered by class name, we can create new instances
 * of project elements by class name without an explicit reference to the type in
 * factory.  This avoids the direct type <=> type circular loop.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class ProjectMeta {

  public static classNameToCtor: {[key: string]: any} = {};

  /** register a class's constructor, but only if not already registered. */
  public static register(className: string, target: any) {

    if (ProjectMeta.classNameToCtor.hasOwnProperty(className)) {

      /* already registered. */

      return ;
    }

    Logger.debug(`[ProjectMeta] project kind: ${className}`, target)

    ProjectMeta.classNameToCtor[!!className ? className : target.name] = target;
  }
}
